<template>
  <v-container fluid grid-list-md>
    <v-card class="pa-3">
      <v-layout row wrap>
        <v-flex sm1>
          <client-title-list-select
            v-model="c.title"
            :outlined="outlinedInputs"
          ></client-title-list-select>
        </v-flex>
        <v-flex sm3>
          <v-text-field
            label="Name"
            required
            @input="$v.c.name.$touch()"
            @blur="$v.c.name.$touch()"
            v-model="c.name"
            :error-messages="nameErrors"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field
            label="Surname"
            required
            @input="$v.c.surname.$touch()"
            @blur="$v.c.surname.$touch()"
            v-model="c.surname"
            :error-messages="surnameErrors"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field
            label="Code"
            v-model="c.code"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm6>
          <client-type-list-select
            v-model="c.clientTypeId"
            :outlined="outlinedInputs"
          ></client-type-list-select>
        </v-flex>
        <v-flex sm6>
          <client-status-list-select
            v-model="c.clientStatusId"
            :outlined="outlinedInputs"
          ></client-status-list-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm4>
          <v-text-field
            label="Telephone"
            v-model="c.telephone"
            mask="phone"
            prepend-inner-icon="mdi-phone"
            :outlined="outlinedInputs"
            required
          ></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field
            label="Mobile"
            v-model="c.mobile"
            mask="phone"
            prepend-inner-icon="mdi-phone"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field
            label="Email"
            @input="$v.c.email.$touch()"
            @blur="$v.c.email.$touch()"
            v-model="c.email"
            type="email"
            prepend-inner-icon="mdi-email"
            :error-messages="emailErrors"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm4>
          <language-list-select
            v-model="c.language"
            :outlined="outlinedInputs"
          ></language-list-select>
        </v-flex>
        <v-flex sm4>
          <nationality-list-select
            v-model="c.nationality"
            :outlined="outlinedInputs"
          ></nationality-list-select>
        </v-flex>
        <v-flex sm4>
          <date-picker
            customLabel="Birth Date"
            :gt-date-string="c.birthDate"
            :range-start="birthDateRangeStart"
            :range-end="birthDateRangeEnd"
            @onDateSelected="onBirthDateChange"
            :outlined="outlinedInputs"
          ></date-picker>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm6>
          <v-row>
            <v-col class="pt-0"
              ><v-text-field
                label="State"
                v-model="c.state"
                :outlined="outlinedInputs"
                hide-details
              ></v-text-field
            ></v-col>
            <v-col class="pt-0">
              <v-text-field
                label="Post/Zip Code"
                v-model="c.postCode"
                :outlined="outlinedInputs"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            ><v-col class="pt-0"
              ><v-text-field
                label="City"
                v-model="c.city"
                :outlined="outlinedInputs"
                hide-details
              ></v-text-field></v-col
          ></v-row>
          <v-textarea
            label="Address"
            v-model="c.address"
            :outlined="outlinedInputs"
          ></v-textarea>
        </v-flex>
        <v-flex sm6>
          <v-textarea
            label="Notes"
            v-model="c.notes"
            :outlined="outlinedInputs"
            rows="10"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <div v-if="debug">{{ c }}</div>
    </v-card>
    <v-layout justify-center pt-3>
      <v-btn class="mr-2" @click="onContact"
        ><v-icon>mdi-email</v-icon>Contact</v-btn
      >
      <save-btn @click="onSave" :disabled="!isValid"></save-btn>
    </v-layout>
    <email-dialog
      :show="showEmailDialog"
      v-model="email"
      @close="showEmailDialog = false"
      @send="onSendMessage"
    ></email-dialog>
  </v-container>
</template>

<script>
var moment = require("moment");
import { required, email } from "vuelidate/lib/validators";
import LanguageListSelect from "../shared/LanguageListSelect";
import NationalityListSelect from "../shared/NationalityListSelect";
import ClientTypeListSelect from "../shared/ClientTypeListSelect";
import ClientTitleListSelect from "../shared/ClientTitleListSelect";
import ClientStatusListSelect from "../shared/ClientStatusListSelect";
import SaveBtn from "../shared/SaveButton";
import EmailDialog from "../shared/EmailDialog.vue";
import { SEND_CLIENT_MESSAGE } from "../../../constants/graphql";
import DatePicker from "../shared/DatePicker.vue";
export default {
  name: "ClientEditorDetails",

  props: {
    client: {
      type: Object,
      default: () => ({
        title: "Mr",
      }),
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    save: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    LanguageListSelect,
    NationalityListSelect,
    ClientTitleListSelect,
    ClientTypeListSelect,
    ClientStatusListSelect,
    SaveBtn,
    EmailDialog,
    DatePicker,
  },
  data() {
    return {
      requireEmail: this.$store.getters.hasAccessTo(
        "clients:client_email_required"
      ),
      debug: false,
      c: { ...this.client, name: "", surname: "", email: "" },
      //titles: ["Mr", "Mrs", "Miss", "Ms", "Dr."],

      showEmailDialog: false,
      email: null,
      birthDateRangeStart: moment("1900-08-01").format("YYYY-MM-DD"),
      birthDateRangeEnd: moment().format("YYYY-MM-DD"),
    };
  },

  methods: {
    onContact() {
      this.email = {
        emailTo: this.c.email,
        message: "",
      };
      this.showEmailDialog = true;
    },
    onSendMessage(payload) {
      this.$apollo
        .mutate({
          mutation: SEND_CLIENT_MESSAGE,
          variables: { input: { ...payload } },
        })
        .then((res) => {
          if (res.data.contactClient.success) {
            this.$store.dispatch("showAppSnackbar", {
              msg: "Message Sent",
            });
            this.showEmailDialog = false;
          } else {
            //res.data.ContactClient.success
            this.$store.dispatch("showAppSnackbar", {
              msg: res.data.contactClient.error,
              color: "error",
            });
          }
        })
        .catch((err) => {
          //console.log(err);
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
          console.log(err);
        });
    },
    onBirthDateChange(date) {
      //this.$refs.birthDateMenu.save(date);
      // this.c.birthDate = moment(date).format("yyyy-MM-ddThh:mm:ss");
      // this.birthDateFormatted = this.$options.filters.formatDate(
      //   this.c.birthDate
      // );
      this.c.birthDate = date;
    },
    onSave() {
      this.$emit("onSave");
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    nameErrors() {
      var errors = [];
      if (!this.$v.c.name.$dirty) return errors;
      !this.$v.c.name.required && errors.push("Name is required.");
      return errors;
    },
    surnameErrors() {
      var errors = [];
      if (!this.$v.c.surname.$dirty) return errors;
      !this.$v.c.surname.required && errors.push("Surname is required.");
      return errors;
    },
    emailErrors() {
      var errors = [];
      if (!this.$v.c.email.$dirty) return errors;
      !this.$v.c.email.required &&
        this.requireEmail &&
        errors.push("Email is required.");
      !this.$v.c.email.email && errors.push("Input must be an email.");
      return errors;
    },
    isValid() {
      return (
        this.c.name != "" &&
        this.c.surname != "" &&
        (this.c.email != "" || !this.requireEmail) &&
        (this.$store.getters.hasAccessTo("clients:edit") ||
          !this.$store.getters.hasAccessTo("clients:view_only"))
      );
    },
  },
  watch: {
    client(data) {
      if (JSON.stringify(data) != JSON.stringify(this.c)) {
        this.c = { ...data };
        if (data.birthDate != null) {
          this.birthDate = moment(data.birthDate).format("YYYY-MM-DD");
          this.birthDateFormatted = this.$options.filters.formatDate(
            data.birthDate
          );
        } else {
          this.birthDate = null;
          this.birthDateFormatted = "";
        }
      }
    },
    c: {
      //readability 10/10 :P
      handler(data) {
        this.$v.$touch();
        if (this.isValid) {
          //isValid is accurate - not $v.$invalid
          this.$emit("onChange", data);
        }
      },

      deep: true,
    },
    birthDateMenu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  validations: {
    c: {
      name: { required },
      surname: { required },
      email: { required, email },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/clients/ClientEditorDetails.vue